import { useRef } from 'react';
import { useUpdateEffect, usePrevious } from 'react-use';
import { Primitive } from 'type-fest';

export const usePreviousHistory = <T extends Primitive>(value: T): T[] => {
  const prevValue = usePrevious(value);
  const history = useRef<T[]>([value]);

  useUpdateEffect(() => {
    if (value !== prevValue) {
      history.current = history.current.concat(value);
    }
  }, [value, prevValue]);

  return history.current;
};
